import { mixedQuestions as fallbackQuestions } from "data/assessmentQuestions";

/**
 * Transforms API questions into the shape the question screens expect.
 * API: { questionText, questionType: "likert"|"forced_choice", options }
 * Screens: { question|statement, type: "rating"|"multiple-choice", options }
 */
const transformApiQuestions = (apiQuestions) => {
  if (!Array.isArray(apiQuestions)) return [];

  return [...apiQuestions]
    .sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0))
    .map((q) => {
      if (q.questionType === "forced_choice") {
        return {
          id: q.id,
          type: "multiple-choice",
          question: q.questionText,
          options: q.options, // { A: { text, archetype }, B: {...} }
        };
      }
      if (q.questionType === "likert") {
        return {
          id: q.id,
          type: "rating",
          statement: q.questionText,
          archetype: q.dimensionCode || null,
        };
      }
      return null;
    })
    .filter(Boolean);
};

/** The form's framework questions, or the bundled question set when it has none. */
export const resolveQuestions = (form) => {
  const transformed = transformApiQuestions(form?.assessmentFramework?.questions);
  return transformed.length > 0 ? transformed : fallbackQuestions;
};

/** Records an answer: option key for multiple choice (partA), 1–5 for ratings (partB). */
export const applyAnswer = (answers, question, value) => {
  if (question.type === "multiple-choice") {
    const keys = Object.keys(question.options);
    return { ...answers, partA: { ...answers.partA, [question.id]: keys[value] || value } };
  }
  if (question.type === "rating") {
    return { ...answers, partB: { ...answers.partB, [question.id]: value } };
  }
  return answers;
};

/** API payload for saveAssessmentResponses. */
export const buildResponses = (questions, answers) =>
  questions.reduce((responses, q) => {
    if (q.type === "multiple-choice" && answers.partA[q.id]) {
      responses.push({ questionId: q.id, value: answers.partA[q.id] });
    } else if (q.type === "rating" && answers.partB[q.id]) {
      responses.push({ questionId: q.id, value: answers.partB[q.id] });
    }
    return responses;
  }, []);

export const organizationOf = (form) => ({
  name: form?.organizationName || form?.organization?.name,
  logo: form?.organizationLogo || form?.organization?.logo,
});
